import { ALLOW_COOKIE } from 'constants';
import Storage from 'utilities/storage';

export const renewSession = ({ refreshToken, renewAction }) => {
    const token = refreshToken || (ALLOW_COOKIE && Storage.cookies.get('refreshToken'));
    if (!token) return;
    renewAction(token);
};
